<template>
  <div class="ml-4 flex flex-col gap-y-4 rounded-sm border border-main bg-surface-elevation-1 p-4">
    <div class="txt-headline-m">
      {{ t('Reviews.product.campaign.form.personalisationPreview.previewBadge') }}
    </div>
    <div class="flex flex-col gap-y-8 rounded-sm border border-main bg-surface p-4 text-center">
      <div class="txt-body-s-bold wrap-break-word text-main">{{ inviteMessage }}</div>
      <div class="txt-label-m text-subtle">{{ t('Reviews.product.campaign.form.personalisationPreview.sub') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  inviteMessage: string
}>()

const { t } = useI18n()
</script>
